{
  "en": {
    "sharedLibrary": {
      "title": "Shared Folder",
      "subline": "Your school’s shared space for teaching materials. Copy what you need and share what helps others – only your colleagues can see it.",
      "tutorial": "View tutorial",
      "paused": {
        "title": "Shared Folder is paused",
        "text": "The school license is no longer active, but materials are preserved.\nAs soon as the license is renewed, you will have access again.",
        "activationLink": "Enter new activation code",
        "modalTitle": "Enter activation code",
        "codeLabel": "School license activation code",
        "codePlaceholder": "Enter school license code…",
        "success": "School license activated! You are now a member of “{groupTitle}”."
      },
      "createMenu": {
        "createNew": "Create New",
        "importFromMyContent": "Copy from My Content",
        "shareContent": "Share content"
      },
      "importDialog": {
        "title": "Copy from My Content",
        "tabLabel": "My Content",
        "searchPlaceholder": "Search term…",
        "confirm": "Copy"
      },
      "search": {
        "placeholder": "Search shared folder..."
      },
      "actions": {
        "copyToMyContent": "Copy to My Content",
        "copyToMyContentPending": "Copying to My Content…",
        "copyToSharedLibrary": "Copy to Shared Folder"
      },
      "folderNotSupported": {
        "title": "Folders cannot be copied to the Shared Folder yet",
        "selectionHint": "Select the contents in the folder and copy them individually or together."
      },
      "copyDialog": {
        "title": "Copy to shared folder",
        "school": "School",
        "folder": "Folder",
        "createFolder": "Create new folder",
        "newFolderName": "New folder name",
        "folderLoadError": "The folders could not be loaded. Please try again."
      },
      "moveDialog": {
        "mixedSelection": "The selected content is in different folders. Moving is only possible within a single folder – select content from only one folder."
      },
      "copyResult": {
        "success": "Content was successfully copied to the Shared Folder",
        "failure": "Your selection could not be copied to the Shared Folder",
        "retry": "Please try again.",
        "responsesNotCopied": "Your students' submissions will not be copied"
      },
      "adoptDialog": {
        "title": "Copy to My Content",
        "folder": "Folder"
      },
      "adoptResult": {
        "success": "Content successfully copied to My Content",
        "failure": "Your selection could not be copied to My Content"
      },
      "schoolSelect": {
        "ariaLabel": "Change School",
        "hint": "Here you can select your school"
      },
      "links": {
        "backToLibrary": "To Shared Folder",
        "trash": "View Trash"
      },
      "emptyState": {
        "root": "There is no content in your school's Shared Folder yet.",
        "folder": "There is currently no content in this folder."
      },
      "noAccess": {
        "noSchool": {
          "title": "You are not yet assigned to a school",
          "text": "The Shared Folder always belongs to a school. Once you are assigned to a school, you will find your colleagues' materials here."
        },
        "disabledBySchool": {
          "title": "Your school has disabled the Shared Folder",
          "text": "The Shared Folder is turned off for your school. Contact your school's license administration if you would like to use it again."
        },
        "refusedBySchool": {
          "title": "This Shared Folder is no longer available to you",
          "text": "Your school is currently not granting you access to this Shared Folder. This happens when your membership has ended or your school has deactivated the Shared Folder. Reload the page or contact your school's license management."
        }
      },
      "copySelectionDialog": {
        "title": "Copy selection to the Shared Folder",
        "school": "School",
        "createFolder": "Create new folder",
        "newFolderName": "Name of the new folder"
      },
      "trash": {
        "heading": "Trash",
        "buttons": {
          "clear": "Empty Trash"
        },
        "emptyTable": "There are currently no removed items in your school's Shared Folder trash.",
        "subline": "Deleted materials and folders remain in the trash for <strong>30 days</strong>. They can be restored until then, after which they will be permanently removed."
      },
      "preview": {
        "loadError": "The content could not be loaded.",
        "noTask": "No task has been saved.",
        "noWords": "No words have been entered yet.",
        "qrCodeAlt": "QR Code for {url}",
        "targetUrl": "Target URL",
        "type": "Type"
      },
      "editorGuard": {
        "noPreview": "Only the creator of this material can edit it."
      }
    }
  }
}
